import LoginStateService, { LOGIN_CHANGE_EVENT, type LoginChangeDetail } from '../Service/LoginStateService'
import { getElementChild, getElements } from '../Utility/Dom'

class LoginButton {
  private readonly buttons: NodeListOf<HTMLElement>

  constructor() {
    this.buttons = getElements('login-button')
  }

  public init(): void {
    if (this.buttons.length === 0) return

    this.applyState(LoginStateService.isLoggedIn())

    document.addEventListener(LOGIN_CHANGE_EVENT, (event: Event): void => {
      this.applyState((event as CustomEvent<LoginChangeDetail>).detail.isLoggedIn)
    })
  }

  private applyState(isLoggedIn: boolean): void {
    this.buttons.forEach((button: HTMLElement): void => {
      button.dataset.state = isLoggedIn ? 'logged-in' : 'logged-out'

      const textElement = getElementChild(button, 'login-button-text')
      if (textElement === null) return

      const loggedOutLabel = button.dataset.labelLoggedOut ?? textElement.textContent?.trim() ?? ''
      const loggedInLabel = button.dataset.labelLoggedIn ?? loggedOutLabel
      textElement.textContent = isLoggedIn ? loggedInLabel : loggedOutLabel
    })
  }
}

const loginButton = new LoginButton()
loginButton.init()
